<template>
	<div class="MAM_queryList">
		<div style="margin-bottom: 20px;">
		    <el-button size="small" icon="el-icon-back" @click="$router.back()">返 回</el-button>
		</div>
		<!-- 顶部银行卡余额 -->
		<div>
			<el-button size="medium" type="primary"  style="font-size: 12px;"
				@click="addCardState = true">添加结算卡</el-button>
			<el-button size="medium" type="primary"  style="font-size: 12px;"
				@click="goCardList">查看结算卡</el-button>
		</div>
		<el-card class="box-card" style="margin-top: 20px;"  shadow="hover">
			
			<div class="headerDiv">
				<div class="headerTitle">奖励可提现余额（元）</div>
				<div style="margin:10px 0px;" class="moneyV">
					<span class="headerMoney">￥{{stockTable.yve_money}}</span>
					<el-button size="medium" type="primary"  style="font-size: 12px;"
						@click="tixianClick">申请提现</el-button>
				</div>
			</div>
			
		</el-card>
		<!-- 表单搜索部分 -->
		<el-card class="box-card" style="margin-top: 20px;"  shadow="hover">
			<el-form :inline="true" :model="queryForm" class="demo-form-inline">

				<el-form-item>
					<el-date-picker type="date" placeholder="提现开始时间" v-model="queryForm.start_time"
						value-format="yyyy-MM-dd" style="width: 150px;"></el-date-picker>
						-
					<el-date-picker type="date" placeholder="提现结束时间" v-model="queryForm.end_time"
						value-format="yyyy-MM-dd" style="width: 150px;"></el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-select size v-model="queryForm.team_status" clearable placeholder="提现状态">
						<el-option label="出款成功" value="2"></el-option>
						<el-option label="审核中" value="1"></el-option>
						<el-option label="待出款" value="4"></el-option>
						<el-option label="出款失败" value="3"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button size="medium" type="primary" icon="el-icon-search" style="font-size: 12px;"
						@click="onSearch(queryForm)">查询</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<!-- 表格部分 -->
		<el-card class="box-card" style="margin-top: 20px;" shadow="hover">
			<div style="margin-bottom:20px">
				<span>提现总金额：{{stockTable.all_money}} 元</span>
			</div>
			<el-table :data="stockTable.list" size="mini" border style="width: 100%" v-loading="loading">
				<el-table-column header-align="center" align="center" prop="create_time" label="提现时间"></el-table-column>
				<el-table-column header-align="center" align="center" prop="money" label="提现金额(元)"></el-table-column>
				<el-table-column header-align="center" align="center" prop="fee_money" label="提现手续费(元)"></el-table-column>
				<el-table-column header-align="center" align="center" prop="service_fee" label="提现服务费(元)"></el-table-column>
				<el-table-column header-align="center" align="center" prop="true_money" label="提现到账金额(元)"></el-table-column>
				<el-table-column header-align="center" align="center" prop="remain_money" label="剩余可提现金额(元)"></el-table-column>
				<el-table-column header-align="center" align="center" prop="team_status_text" label="状态">
					<template slot-scope="scope">
						<span v-if="scope.row.status == 4" style="color:#F56C6C">
							{{scope.row.team_status_text}}
						</span>
						<span v-else>{{scope.row.team_status_text}}</span>
					</template>
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="reject_reason" label="审核原因"></el-table-column>
				<el-table-column header-align="center" align="center" prop="repay_time" label="出款时间"></el-table-column>
				<el-table-column header-align="center" align="center" prop="bank_code" label="到账银行卡"></el-table-column>
				<el-table-column header-align="center" align="center" prop="bank_name" label="银行卡总行"></el-table-column>
			
			</el-table>
			<!-- 分页部分 -->
			<paginations :currentPage="page.currentPage" :pageSize="page.pageSize" :total="page.total"
				@watchCurrent="getCurrent" @watchPageSize="getPageSize"></paginations>
		</el-card>
		
		<el-dialog title="添加结算卡" :visible.sync="addCardState" class="dialog">
		  <el-form  label-position="right" :model="addForm" ref="addForm" label-width="120px"  :rules="rules" >
		    <el-form-item label="账户名称:"  >
		      <el-input  :disabled="true" v-model="addForm.name" autocomplete="off"></el-input>
		    </el-form-item>
		     <el-form-item label="开户银行:" required  prop="bank_id">
				<el-select filterable v-model="addForm.bank_id" placeholder="请选择开户银行">
				  <el-option v-for="(item,index) in banklist" :key="item.bank_name" :label="item.bank_name" :value="item.id"></el-option>
				</el-select>
		      </el-form-item>
			  <el-form-item label="银行卡号:" required   prop="bank_code">
			    <el-input placeholder="请输入银行卡号"  v-model="addForm.bank_code" autocomplete="off"></el-input>
			  </el-form-item>
			  <el-form-item label="银行预留手机号:" required  prop="phone">
				<el-col :span="18">
					<el-input placeholder="请输入预留手机号" v-model="addForm.phone" autocomplete="off"></el-input>
				</el-col>
			    <el-col :span="6">
			    	<el-button :style="{'color':codeState==true?'#999999':'#FF8532', 'border-color':codeState==true?'#999999':'#FF8532','margin-left':'10px','font-size': '12px'}"  size="medium" 
			    		@click="codeClick">{{codeState==true?seconds + 's':'获取验证码'}}</el-button>
			    </el-col>
			  </el-form-item>
			  <el-form-item label="验证码:" required  prop="code">
			    <el-input placeholder="请输入验证码"  v-model="addForm.code" autocomplete="off"></el-input>
			  </el-form-item>
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button @click="addCardState = false">取 消</el-button>
		    <el-button type="primary" @click="addSubmit('addForm')">确 定</el-button>
		  </div>
		</el-dialog>
		
		
		
		<el-dialog title="申请提现" :visible.sync="tixianCardState" class="dialog">
		  <el-form  label-position="right" :model="tixianForm" ref="tixianForm" label-width="120px"  :rules="rules" >
		    <el-form-item label="当前可提现余额:"  >
				<span class="yveMoney">
					￥{{tixianForm.money}}元
				</span>
		    </el-form-item>
			<el-form-item label="提现金额:"  >
				<span class="yveMoney">
					￥{{tixianForm.money}}元
				</span>
			</el-form-item>
			<el-form-item label="选择银行卡:" required  prop="user_bank_id">
				<el-select v-model="tixianForm.user_bank_id" placeholder="请选择银行卡">
					 <el-option v-for="(item,index) in cardList" :label="item.bank_name + '  ' + item.bank_code" :value="item.id"></el-option>
				</el-select>
			 </el-form-item>
			<el-form-item label="开户名称:"  >
				<span class="yveMoney">
					{{addForm.name}}
				</span>
			</el-form-item>
		     
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button @click="tixianCardState = false">取 消</el-button>
		    <el-button type="primary" @click="tixianSubmit('tixianForm')">确 定</el-button>
		  </div>
		</el-dialog>
		
		
		
		
		<el-dialog title="查看结算卡" :visible.sync="canCardState" class="dialog">
			<div class="cardList">
				<div class="cardItem" v-for="(item,index) in cardList" :key="item.id" :style="{'border-bottom-width':cardList.length == (index+1) ? '0px':'1px'}">
					<img :src="require('../../../assets/images/cardlogo.png')" class="cardlogo">
					<div class="cardItemRight">
						<div class="cardItemRightTitle">{{item.bank_code}}</div>
						<div class="cardItemRightTitle">{{item.bank_name}}</div>
					</div>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
			  <el-button @click="canCardState = false">取 消</el-button>
			</div>
		  
		</el-dialog>
		
		
	</div>
</template>

<script>
	import { Message } from 'element-ui';
	import paginations from '../../../components/pagination/paginations';
	export default {
		name: "tixianManger",
		data() {
			return {
				queryForm: {
					user_id: this.$route.query.user_id,
					team_status:'',
					is_list:2,
					start_time:'',
					end_time:'',
				},
				stockTable: { //列表
					list: [],
					all_money:0,
					yve_money:0,
					is_with_draw:2  //是否允许提现 1允许提现 2不允许
				},
				page: {
					currentPage: 1, //当前页码
					pageSize: 10, //条数
					total: 100 //总数
				},
				loading: true,
				downLoading:false,
				addCardState:false,
				canCardState:false,
				tixianCardState:false,
				addForm:{
					user_id:this.$route.query.user_id,
					name:'',
					bank_id:'',
					bankName:'',
					bank_code:'',
					phone:'',
					code:''
				},
				rules: {
					bank_id: [{
						required: true,
						message: '请选择开户银行',
						trigger: 'change'
					}],
					bank_code: [{
						required: true,
						message: '请输入银行卡号',
						trigger: 'blur'
					}],
					phone: [{
						required: true,
						message: '请输入银行预留手机号',
						trigger: 'blur'
					}],
					user_bank_id: [{
						required: true,
						message: '请选择银行卡',
						trigger: 'change'
					}],
					code: [{
						required: true,
						message: '请输入验证码',
						trigger: 'blur'
					}],
				},
				tixianForm:{
					user_id:this.$route.query.user_id,
					yve:'0.00',
					money:'0.00',
					name:'',
					user_bank_id:''
				},
				banklist:[],
				codeState: false,
				seconds: 59,
				cardList:[]
				
			}
		},
		mounted() {
			this.getData({
				page: this.page.currentPage,
				limit: this.page.pageSize,
				user_id: this.$route.query.user_id,
				is_list:2
			})
			this.getbankList()
			this.getCardList()
			this.getAgentMessage()
		},
		components: {
			paginations,
		},
		methods: {
			// 提现操作
			tixianClick(){
				if (this.cardList == undefined || this.cardList.length == 0) {
					this.$message({
					    message: '请先添加结算卡'
					});
				}else {
					this.tixianCardState = true
				}
			},
			// 查看结算卡操作
			goCardList(){
				if (this.cardList == undefined || this.cardList.length == 0) {
					this.$message({
					    message: '请先添加结算卡'
					});
				}else {
					this.canCardState = true
				}
				
			},
			// 获取银行卡列表
			getbankList(){
				this.$api.post('bank/list', {}, res => {
					console.log(res);
					this.banklist = res.data
					
							
				})
			},
			// 获取当前代理商信息
			getAgentMessage(){
				let params = {
					user_id:this.$route.query.user_id
				}
				this.$api.post('userteamleader/beforeQueryUser', params, res => {
					console.log(res);
					this.addForm.name = res.data.real_name		
				})
			},
			// 获取银行列表
			getCardList(){
				let params = {
					user_id:this.$route.query.user_id
				}
				this.$api.post('userteamleader/getUserTeamBankList', params, res => {
					console.log(res);
					this.cardList = res.data.data		
				})
			},
			// 添加结算卡
			addSubmit(ruleName){
				this.$refs[ruleName].validate((valid) => {
					if (valid) {
						this.$api.post('userteamleader/saveUserTeamBank', this.addForm, res => {
							if (res.code == 0) {
								this.$message({
								    message: '添加成功',
									type:'success'
								});
								this.addCardState = false
								this.addForm.bank_id = ''
								this.addForm.bank_code = ''
								this.addForm.code = ''
								this.addForm.phone = ''
								this.getCardList()
							}else {
								this.$message({
								    message: res.msg
								});
							}
							
						})
						
					}
					
				})
			},
			// 提现确认操作
			tixianSubmit(ruleName){
				this.$refs[ruleName].validate((valid) => {
					if (valid) {
						this.$refs[ruleName].validate((valid) => {
							if (valid) {
								this.$api.post('user_team/withdrawApply', this.tixianForm, res => {
									if (res.code == 0) {
										this.$message({
										    message: '提交成功，等待审核',
											type:'success'
										});
										this.tixianCardState = false
										this.getPageSize(10);
									}else {
										this.$message({
										    message: res.msg
										});
									}
									
								})
								
							}
							
						})
						
					}
					
				})
			},
			// 获取验证码
			codeClick(){
				if (this.addForm.phone.length == 0) {
					this.$message({
                        message: '请输入手机号'
                    });
					return
				}
				if (this.addForm.phone.length != 11) {
					this.$message({
					    message: '请输入正确的手机号'
					});
					return
				}
				
				let params = {
					phone:this.addForm.phone,
					type:'8'
				}
				if (this.codeState === true) {
					return
				}
				this.$api.post('send/sms', params, res => {
					this.$message({
					    message: '发送成功',
						type:'success'
					});
					this.codeState = true;
					 const number =	setInterval((res)=>{
						let second = this.seconds - 1;
						this.seconds = second;
						if(second == 0){
						     clearInterval(number)
							 this.seconds = 59;
							 this.codeState = false;
						 }
					  },1000)
							
				})
				
				
			},
			
			handleDownLoad(params) { //导出
				let reqData = {
					type: 12,
					value: JSON.stringify(params)
				};
			
				this.downLoading = true;
				this.$api.post('export/add', reqData, res => {
					if (res.code == 0) {
						this.$message.success(res.msg);
						this.downLoading = false;
					} else {
						this.$message.error(res.msg);
						this.downLoading = false;
					}
			
				})
			},
			onSearch(queryForm) {
				this.page.currentPage = 1;
				queryForm.page = this.page.currentPage;
				queryForm.limit = this.page.pageSize;
				queryForm.user_id = this.$route.query.user_id;
				queryForm.is_list = 2;
				// 表单提交
				this.getData(queryForm);
			},
			//分页
			getCurrent(page) {
				// 获取当前页修改的值
				this.page.currentPage = page;
				this.loading = true;
				this.queryForm.page = page;
				this.queryForm.limit = this.page.pageSize;
				this.getData(this.queryForm);
			},
			getPageSize(limit) {
				this.page.currentPage = 1;
				// 获取条数发生改变的值
				this.page.pageSize = limit;
				this.loading = true;
				this.queryForm.page = this.page.currentPage;
				this.queryForm.limit = limit;
				this.getData(this.queryForm);
			},
			getData(params) {
				this.$api.post("userteamleader/getUserTeamWithdrawList", params, res => {
					let data = res.data.data;
					this.page.total = data.list.total; //总数
					this.stockTable.list = data.list.data;
					this.stockTable.all_money = data.with_draw_money;
					this.stockTable.yve_money = data.reward_money;
					this.tixianForm.money = data.reward_money;
					this.stockTable.is_with_draw = data.is_with_draw;
					// //渲染结束后取消加载
					this.loading = false;
				})
			}
		}
	};
</script>

<style lang="scss" scope>
	.MAM_queryList {
		.el-input__inner {
			font-size: 12px;
		}

		.el-form-item {
			margin-bottom: 5px;
		}
	}
	.headerDiv {
		padding: 0px 40px;
		font-size: 14px;
		color: #E6A23C;
	}
	
	.headerMoney {
		font-size: 26px;
		margin-right: 40px;
	}
	.headerTitle {
		font-size: 28px;
	}
	.moneyV {
		display: flex;
		align-items: center;
	}
	.dialog {
		.el-form-item {
			margin-bottom: 20px !important;
		}
		.el-select {
			width: 100% !important;
		}
	}
	.cardList {
		display: flex;
		flex-direction: column;
		width: 90%;
		margin-left: 5%;
		border: 1px solid rgb(224, 224, 224);
		.cardItem {
			width: 100%;
			height: 100px;
			border-bottom: 1px dashed rgb(224, 224, 224);
			display: flex;
			align-items: center;
			.cardlogo {
				width:50px;
				height:50px;
				margin-left:30px;
			}
			.cardItemRight {
				display: flex;
				flex-direction: column;
				justify-content: center;
				font-size:15px;
				margin-left:10px;
				
				.cardItemRightTitle {
					height: 25px;
					line-height: 25px;
				}
			}
			
		}
	}
	
</style>